<template>
  <keep-alive v-if="AtopicDermatitisNodeComponent">
    <component :is="AtopicDermatitisNodeComponent" :content="content" v-bind="nodeData" :disabled="disabled" />
  </keep-alive>
  <div v-else>atopic dermatitis form node not found</div>
</template>

<script>
import { PropsDefinition } from '@/_typedefs'
import ScoradFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/ScoradParameterNode.vue'
import EasiBsaFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/EasiBsaParameterNode.vue'
import IgaFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/IgaParameterNode.vue'
import WiNrsFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/WiNrsFormNode.vue'
import PtIgaFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/PtIgaFormNode.vue'
import PoemFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/PoemFormNode.vue'
import AdctFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/AdctFormNode.vue'
import ReportFormNode from './FormNodes/Report/ReportFormNode.vue'
import PruritusSleepFormNode from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/PruritusSleepFormNode.vue'
import MedicinesFormNode from './FormNodes/Medicines/MedicinesFormNode.vue'
import LmeFormNode from './FormNodes/Lme/LmeFormNode.vue'

/**
 * @typedef {Object} AtopicDermatitisFormNodeProps
 * @property {string} kind
 * @property {object} nodeData
 * @property {FormNodeProps | FormNodeProps[]} content
 */

export default {
  name: 'AtopicDermatitisFormNode',
  /** @type {PropsDefinition<AtopicDermatitisFormNodeProps>} */
  props: {
    kind: {
      type: String,
      required: true,
    },
    nodeData: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: [Array, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** @type {Computed<Component?>} */
    AtopicDermatitisNodeComponent() {
      if (this.kind.match(/:/g)?.length ?? 0 >= 2) {
      }

      const nodeMap = {
        'atopic-dermatitis:scorad': ScoradFormNode,
        'atopic-dermatitis:easi+bsa': EasiBsaFormNode,
        'atopic-dermatitis:iga': IgaFormNode,
        'atopic-dermatitis:wi-nrs': WiNrsFormNode,
        'atopic-dermatitis:pt-iga': PtIgaFormNode,
        'atopic-dermatitis:poem': PoemFormNode,
        'atopic-dermatitis:adct': AdctFormNode,
        'atopic-dermatitis:pruritus-sleep': PruritusSleepFormNode,
        'atopic-dermatitis:report': ReportFormNode,
        'atopic-dermatitis:medicines': MedicinesFormNode,
        'atopic-dermatitis:lme': LmeFormNode,
      }

      return nodeMap[this.kind] ?? null
    },
  },
}
</script>

<style></style>
